import Vue from "vue";
import Vuex from "vuex";
import Service from "../../../service/api.js";
import ServiceHR from "../../../service/api-hr.js";
import router from "../../../router/index.js";
import store from "@/store/store";

const LoginModule = {
    namespaced: true,
    state: {
        isSignIn:true,
        userId:"66d1491da8ecd8d7d08981c2"

    },

    mutations: {
        isSignIn(state, obj) {
            state.isSignIn = obj
        },

        userId(state, obj) {
            state.userId = obj
        },


    },

    actions: {
        supportReload({commit}, data) {

            var objs = JSON.parse(localStorage.getItem('objs'));

            store.commit('xAccessToken',objs.xAccessToken)
            // store.commit('accounts',objs.accounts)
            store.commit('auth/userId',objs.accounts)
            store.dispatch('personal/config',{})

        },


        singin({commit}, data) {
            store.commit("dialog/loading",true)
            Service.singin(data)
                .then((response) => {

                    store.commit("auth/isSignIn",false)
                    var objs = JSON.stringify(response.data.data)
                    localStorage.setItem('objs',objs);

                    store.dispatch("auth/supportReload",{})
                    store.commit("dialog/loading",false)


                    router.push('/estimate/yourself');
                })
                .catch((err) => {
                    store.commit("dialog/loading",false)

                    var dialog = {
                        message: "Username และ Password ไม่ถูกต้อง",
                        code:"40100",
                        number :"1",
                        status:true
                    }
                    store.commit("dialog/dialog",dialog)
                });
        }

    },

    getters: {
        isSignIn(state) {
            return state.isSignIn;
        },

        userId(state) {
            return state.userId;
        },
    },
};

export default LoginModule;
